// Phase 3 D-03 — IST timezone math. Node 23 ICU support is sufficient; no external deps.

export interface IstDateParts {
  year: string;
  month: string;
  day: string;
  hour: string;
}

export function getIstDateParts(date: Date): IstDateParts {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce<Record<string, string>>((acc, p) => {
      acc[p.type] = p.value;
      return acc;
    }, {});
  return {
    year: parts["year"] ?? "",
    month: parts["month"] ?? "",
    day: parts["day"] ?? "",
    hour: parts["hour"] ?? "",
  };
}

/** Returns 'YYYY-MM-DD' for the given moment as observed in IST. */
export function getIstDateString(date: Date): string {
  return date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
}

/** True iff the given moment lies on the 1st of a month in IST. */
export function isFirstOfMonthInIST(date: Date): boolean {
  return getIstDateParts(date).day === "01";
}

/** Returns the last day-of-month integer for {year, month} where month is 1..12. */
export function lastDayOfMonthInIST(opts: { year: number; month: number }): number {
  // JavaScript Date: month is 0-indexed; day=0 of next month yields last day of given month.
  return new Date(Date.UTC(opts.year, opts.month, 0)).getUTCDate();
}
